export default __webpack_public_path__ + "static/media/slide19.017011b0.jpg";